const workercode = () => {
  onmessage = (e) => {
    /* eslint-disable */
    importScripts(e.data.link);
    /* eslint-disable */
    let maxSamples = 1152;
    /* eslint-disable */
    let wav = new lamejs.WavHeader.readHeader(new DataView(e.data.arrayBuffer));
    /* eslint-disable */
    if (!wav) {
      return;
    }

    var dataView = new Int16Array(
      e.data.arrayBuffer,
      wav.dataOffset,
      wav.dataLen / 2
    );
    let samplesLeft =
      wav.channels === 1
        ? dataView
        : new Int16Array(wav.dataLen / (2 * wav.channels));
    let samplesRight =
      wav.channels === 2
        ? new Int16Array(wav.dataLen / (2 * wav.channels))
        : undefined;
    if (wav.channels > 1) {
      for (var i = 0; i < samplesLeft.length; i++) {
        samplesLeft[i] = dataView[i * 2];
        samplesRight[i] = dataView[i * 2 + 1];
      }
    }

    /* eslint-disable */
    let mp3Encoder = new lamejs.Mp3Encoder(wav.channels, wav.sampleRate, 128);
    /* eslint-disable */

    var remaining = samplesLeft.length;
    let mp3Data = [];
    for (var i1 = 0; remaining >= maxSamples; i1 += maxSamples) {
      var left = samplesLeft.subarray(i1, i1 + maxSamples);
      var right;
      if (samplesRight) {
        right = samplesRight.subarray(i1, i1 + maxSamples);
      }
      var mp3buf = mp3Encoder.encodeBuffer(left, right);
      mp3Data.push(new Int8Array(mp3buf));
      remaining -= maxSamples;
    }

    var blob = new Blob(mp3Data, { type: "audio/mp3" });
    postMessage(blob);
  };
};

let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

export default worker_script;
